import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export default {
  finish(informations) {
    return http.post('/job/whatsapp/finish', informations);
  },

  close(informations) {
    return http.post('/job/whatsapp/close', informations);
  },

  updateFieldsScript({ protocol, fields, channel }) {
    return http
      .post(`/job/answer/${protocol}`, { fields, channel })
      .then((res) => res.data);
  },

  getMessagesFromJob(protocol) {
    return http.get(`/job/${protocol}/messages`).then(handleResponse);
  },

  async getJobsActive(agentId) {
    try {
      const { data } = await http.get(`/agents/${agentId}/jobs/active`);
      return data;
    } catch (err) {
      throw new Error('Não foi possível recuperar os atendimentos ativos.');
    }
  },

  postAckCallRequest(callInformation) {
    try {
      return http.post('/job/voice/reject', callInformation);
    } catch (err) {
      throw new Error('Nao foi possivel recusar o atendimento');
    }
  },

  readAllMessages(agentId, protocol) {
    return http
      .post('whatsapp/read-all', {
        agent_id: agentId,
        protocol,
      })
      .then(handleResponse);
  },
};

export const finishChatJob = (finish) =>
  http.post('/job/chat/finish', finish).then(handleResponse);

export const getInboxJobs = (agentId) =>
  http.get(`/agents/${agentId}/jobs/inbox`).then(handleResponse);

export const getTransfers = (protocol) =>
  http.get(`/job/${protocol}/transfers`).then(handleResponse);

export const fetchWhatsappPin = async (agent_id, protocol) => {
  try {
    await http.post('/whatsapp/pin', { agent_id, protocol });
    return true;
  } catch (err) {
    throw new error(err);
  }
};

export const fetchWhatsappUnPin = async (agent_id, protocol) => {
  try {
    await http.post('/whatsapp/unpin', { agent_id, protocol });
    return true;
  } catch (err) {
    throw new error(err);
  }
};

export const fetchWhatsappRead = async (agent_id, protocol) => {
  try {
    await http.post('/whatsapp/read', { agent_id, protocol });
    return true;
  } catch (err) {
    throw new error(err);
  }
};

export const fetchWhatsappUnRead = async (agent_id, protocol) => {
  try {
    await http.post('/whatsapp/unread', { agent_id, protocol });
    return true;
  } catch (err) {
    throw new error(err);
  }
};
